import { Constants } from '@/constants';

export class EliUsageMetrics {
	static readonly METRIC_ID_CURRENT_MONTH = 'eli_metrics_current_month';

	static readonly METRIC_ID_PREVIOUS_MONTH = 'eli_metrics_previous_month';
}

export const ELI_CHAT_TYPING_SPEED = 30; // ms

// keep in sync with EliContextDataGenerator.php
export const ELI_CONTEXT_PROJECT_HEALTH = 'projectHealth';
export const ELI_CONTEXT_PATH = 'path';
export const ELI_CONTEXT_THREAD_ID = 'threadId';

export const ELI_AVATAR_PROJECT_HEALTH = `${Constants.Assets.CDN_URL}/eli/ELI_health.png`;
export const ELI_AVATAR_ROBOT = `${Constants.Assets.CDN_URL}/eli/ELI_robot.png`;
export const ELI_AVATAR_INSIGHTS = `${Constants.Assets.CDN_URL}/eli/ELI_insights_head_noshadow.png`;
